const fragShader = `
precision mediump float;
uniform float iTime;
uniform float starsIntensity;
uniform float textureBrightness;
uniform float shadowIntensity;
uniform float shadowAlpha;
uniform vec2 iResolution;
uniform sampler2D uMainSampler;
varying vec2 outTexCoord;

#define v3 vec3
#define R iResolution.xy

vec3 H(v3 p) {
    return fract(sin(v3(
        dot(p, v3(1.0, 57.0, 113.0)),
        dot(p, v3(57.0, 113.0, 1.0)),
        dot(p, v3(13.0, 1.0, 57.0))
    )) * 43.0);
}

float D(v3 x, v3 y, float p) {
    return clamp(pow(
        pow(abs(x.x - y.x), p) +
        pow(abs(x.y - y.y), p) +
        pow(abs(x.z - y.z), p), 1.0 / p), 0.0, 1.0);
}

float N(vec3 p) {
    float d = 1e9, m;
    v3 i, v;
    for (float z = -1.0; z <= 1.0; z++) {
        i.z = z;
        for (float y = -1.0; y <= 1.0; y++) {
            i.y = y;
            for (float x = -1.0; x <= 1.0; x++) {
                i.x = x;
                v = i - fract(p) + H(floor(p) + i);
                m = D(v, v3(0.0), 0.5);
                d = min(d, m);
            }
        }
    }
    return d;
}

void mainImage(out vec4 c, vec2 u) {
    vec4 startColor = texture2D(uMainSampler, outTexCoord);

    float t = iTime * 0.02, n;
    u *= vec2(R.x / R.y, 1.0) / R.xy;
    vec2 p = (outTexCoord * 2.0 - 1.0) * iResolution.y / iResolution.xy / 6.0;
    v3 u3 = v3(p.x -2., p.y - 2. + t * 2.0, t) * starsIntensity;
    n = textureBrightness - N(u3);

    if (startColor.r < 0.2 && startColor.g < 0.2 && startColor.b < 0.2 && startColor.a > 0.1) {
        c = vec4(startColor.r - shadowIntensity, startColor.g - shadowIntensity, startColor.b - shadowIntensity, startColor.a + shadowAlpha);
    } else {
        c = vec4(n, n, n, startColor.a) * startColor;
    } 
    // c = startColor;
}

void main() {
    mainImage(gl_FragColor, gl_FragCoord.xy);
}
`;

export class StarsPipeline extends Phaser.Renderer.WebGL.Pipelines.SinglePipeline {
    constructor(game, starsIntensity = 17, textureBrightness = 2, shadowIntensity = 0.2, shadowAlpha) {
        super({
            game,
            fragShader,
            uniforms: ['iTime', 'iResolution', 'uMainSampler']
        });

        this.starsIntensity = starsIntensity;
        this.textureBrightness = textureBrightness;
        this.shadowIntensity = shadowIntensity;
        this.shadowAlpha = shadowAlpha;
    }

    onPreRender() {
        this.set1f('iTime', this.game.loop.time / 800);
        this.set1f('starsIntensity', this.starsIntensity);
        this.set1f('textureBrightness', this.textureBrightness);
        this.set1f('shadowIntensity', this.shadowIntensity);
        this.set1f('shadowAlpha', this.shadowAlpha);
        this.set2f('iResolution', 1250, 1250);
    }
}
